var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0003 35C49.0003 41.4423 43.776 46.6667 37.3337 46.6667H32.667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.167 43.1667L32.667 46.6667L36.167 50.1667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21C7 14.5577 12.2243 9.33334 18.6667 9.33334H23.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.833 12.8333L23.333 9.33334L19.833 5.83334",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9659 26.0027C43.8409 25.1277 44.3332 23.94 44.3332 22.7033L43.8259 13.3913C37.1302 18.7826 38.6139 17.9969 37.7389 18.8696L28.6085 27.3913C24.3467 31.6522 26.7824 29.2174 16.4346 38.9565L20.4819 43.246C21.9285 44.6927 24.2759 44.6927 25.7225 43.246L42.9659 26.0027Z",
    fill: "#F25926"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8827 19.117C37.221 19.4553 37.221 20.0037 36.8827 20.342C36.5443 20.6803 35.996 20.6803 35.6577 20.342C35.3193 20.0037 35.3193 19.4553 35.6577 19.117C35.9983 18.7787 36.5443 18.7787 36.8827 19.117",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.297 11.6667H39.667C42.2453 11.6667 44.3337 13.755 44.3337 16.3333V22.7033C44.3337 23.94 43.8413 25.1277 42.9663 26.0027L25.723 43.246C24.2763 44.6927 21.929 44.6927 20.4823 43.246L12.752 35.5157C11.3053 34.069 11.3053 31.7217 12.752 30.275L29.9953 13.0317C30.8703 12.159 32.058 11.6667 33.297 11.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.0ae9f8b5c7760d5b772e2bc18a3f2cc2.svg";
export { ForwardRef as ReactComponent };